import { render } from "./ProfileMember.vue?vue&type=template&id=9f400e40"
import script from "./ProfileMember.vue?vue&type=script&lang=js"
export * from "./ProfileMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__